import { SvgIcon, SvgIconProps } from '@mui/material'

const BookIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 25.617 34">
    <g transform="translate(-5.58 -2.17)">
      <path d="M30.275 36.17a.929.929 0 0 0 .922-.922V3.092a.929.929 0 0 0-.922-.922H8.96a3.378 3.378 0 0 0-3.38 3.38v27.19A3.42 3.42 0 0 0 9 36.158h21.275zM7.424 5.55A1.537 1.537 0 0 1 8.96 4.014h20.393V29.3H9a3.4 3.4 0 0 0-1.586.393V5.55zm0 27.19a1.6 1.6 0 0 1 1.586-1.6h20.355v3.171H9a1.542 1.542 0 0 1-1.119-.467 1.511 1.511 0 0 1-.457-1.104z" />
      <path
        d="M11.462 13.809h13.079a.929.929 0 0 0 .922-.922V7.442a.929.929 0 0 0-.922-.922H11.462a.929.929 0 0 0-.922.922v5.445a.921.921 0 0 0 .922.922zm.922-5.445h11.235v3.6H12.384z"
        transform="translate(1.137 .997)"
      />
    </g>
  </SvgIcon>
)

export default BookIcon
